import React, { useState } from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import { Anchor, ShieldCheck } from "lucide-react";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("director@eigoo.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await login(email, password);
    setBusy(false);
  };

  return (
    <div className="relative min-h-screen overflow-hidden flex items-center justify-center px-4">
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage:
            "url('https://static.prod-images.emergentagent.com/jobs/4f56bc46-9ed9-46f3-bea8-9d960ca9759f/images/6206429cab63f493097092238009eeae506799f72aeb3c945b5532fbcf13939d.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.55,
        }}
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#040404]/70 via-[#040404]/85 to-[#040404]" />

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
        className="relative w-full max-w-md"
      >
        <div className="glass-panel-strong angled-corner relative grain p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-10 w-10 grid place-items-center border border-[#D8AB4E]/40 angled-corner">
              <Anchor size={18} className="text-[#D8AB4E]" />
            </div>
            <div>
              <div className="label-mono text-[#D8AB4E]">EIGOO // GRAND COMMANDER</div>
              <div className="font-display text-2xl">Sovereign Battleship</div>
            </div>
          </div>

          <div className="gold-divider mb-8" />

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="label-mono text-zinc-400 mb-2 block">Commander Identifier</label>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#0A0A0A] border border-[#D8AB4E]/30 px-4 py-3 text-white text-sm focus:outline-none focus:border-[#D8AB4E] transition-colors"
                placeholder="director@eigoo.com"
                required
              />
            </div>
            <div>
              <label className="label-mono text-zinc-400 mb-2 block">Sovereign Cipher</label>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#0A0A0A] border border-[#D8AB4E]/30 px-4 py-3 text-white text-sm focus:outline-none focus:border-[#D8AB4E] transition-colors"
                placeholder="••••••••••••"
                required
              />
            </div>

            {error && (
              <div data-testid="login-error" className="text-xs font-mono-data text-[#E55A45] border-l-2 border-[#C1432E] pl-3">
                {error}
              </div>
            )}

            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={busy}
              className="btn-gold w-full py-3 text-xs disabled:opacity-50"
            >
              {busy ? "AUTHENTICATING…" : "TAKE THE BRIDGE"}
            </button>
          </form>

          <div className="mt-8 flex items-center gap-2 text-[10px] font-mono-data tracking-[0.2em] text-zinc-500">
            <ShieldCheck size={12} className="text-[#D8AB4E]" />
            ENCRYPTED SIGNAL · MFA-READY · SOVEREIGN
          </div>
        </div>

        <div className="mt-6 text-center">
          <div className="font-mono-data text-[10px] tracking-[0.3em] text-zinc-500">
            OWN THE SIGNAL. STAT.
          </div>
        </div>
      </motion.div>
    </div>
  );
}
